<template>
    <div class="mark_box" @mousewheel.prevent="rollImg">
        <div span="8" class="left" @mousedown="move">
           <img :src="image" alt="" class="img" :style="{'zoom':0.15}" ref="imgDiv"/>
           <div class="marker" :class="item.type" v-for="(item,index) in markerList" :key="index" :style="{'left': ((item.x-12)*imgheight/100)+'px','top': ((item.y-15)*imgheight/100)+'px','position': 'absolute'}">
                <!-- {{ item.id }} -->
                <img class="img_show" :src="item.icon"/>
                <div class="tip_triangle"></div>
                <div class="tips" style="z-index: 13;" @click="fnGoPage(item)">
                    <div class="tip_icon">
                        <img :src="item.icon"/>
                    </div>
                    <div class="tip_text">
                        <div class="tip">标点类型:{{ item.pointType }}</div>
                        <div class="tip">设备编号:{{ item.pointNumber }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { setActiveIndex, setEqptInfo } from '@/utils/auth';
export default {
    props: {
        markerPoint: Object
    },
    data() {
        return {
            imgtop: 0, //图片距离左边的距离
            imgleft: 0, //图片距离上边的距离
            imgheight: 100, //图片高度百分比
            imgHeights: null,// 图片高度
            imgWidths: null,// 图片宽度
            DownUp: false, //用来判断鼠标是否长按
            markerList: [],
            image: '',
            markerListAll: []
        };
    },
    watch: {
        markerPoint: {
            immediate: true,
            deep: true,
            handler: function(newV) {
                this.image = newV.image;
                this.markerList = newV.markerList;
                this.imgHeights = newV.imgHeight;
                this.imgWidths = newV.imgWidth;
            }
        }
    },
    mounted() {
      this.markerListAll = JSON.parse(JSON.stringify(this.markerList))
      for(let i in this.markerList){
          this.markerList[i].x = this.markerList[i].x*0.15
          this.markerList[i].y = this.markerList[i].y*0.15
      }
    },
    methods: {
        // 拖动图片
        move(e) {
            e.preventDefault();
            var left = document.querySelector('.mark_box');
            var img = document.querySelector('.left');
            var x = e.pageX - img.offsetLeft;
            var y = e.pageY - img.offsetTop;
            // 添加鼠标移动事件
            left.addEventListener('mousemove', move);
            function move(e) {
                img.style.left = e.pageX - x + 'px';
                img.style.top = e.pageY - y + 'px';
            }
            // 添加鼠标抬起事件，鼠标抬起，将事件移除
            img.addEventListener('mouseup', function() {
                left.removeEventListener('mousemove', move);
            });
            // 鼠标离开父级元素，把事件移除
            left.addEventListener('mouseout', function() {
                left.removeEventListener('mousemove', move);
            });
        },
        // 缩放图片
        rollImg() {
            this.markerList = JSON.parse(JSON.stringify(this.markerListAll))
            /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
            var zoom = parseInt(this.$refs.imgDiv.style.zoom) || 15;
            /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */
            zoom += event.wheelDelta / 12;
            /* 最小范围 和 最大范围 的图片缩放尺度 */
            if (zoom >= 10 && zoom < 500) {
                this.imgheight = zoom
                this.$refs.imgDiv.style.zoom = zoom + '%';
            }
            return false;
        },
        // 页面跳转
        fnGoPage(item){
            setActiveIndex('3')
            setEqptInfo(item)
            this.$router.push({ path: item.url});
        }
    }
};
</script>
<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.mark_box{
    // 820.8
    // 547.2  0.15
    // width: 830px;
    // height: 680px;
    width: 820.8px;
    height: 547.2px;
    position: relative;
    overflow: hidden;
}
.left {
    position: absolute;
    .img {
        // width: 820.8px;
        // height: 547.2px;
        // zoom: 0.15;
        cursor: move;
    }
    .marker{
        width: 24px;
        height: 30px;
        line-height: 24px;
        color: #FFFFFF;
        border-radius: 6px;
        font-size: 12px;
        text-align: center;
        padding: 3px 4px 11px;
        &.monitor{
            background: url(../../../assets/img/loc_b.png) no-repeat;
            background-size: 100% 100%;
        }
        &.led{
            background: url(../../../assets/img/loc_g.png) no-repeat;
            background-size: 100% 100%;
        }
        &.tower{
            background: url(../../../assets/img/loc_p.png) no-repeat;
            background-size: 100% 100%;
        }
        &.elevator{
            background: url(../../../assets/img/loc_r.png) no-repeat;
            background-size: 100% 100%;
        }
        &.environment{
            background: url(../../../assets/img/loc_y.png) no-repeat;
            background-size: 100% 100%;
        }
        &.helmet{
            background: url(../../../assets/img/loc_z.png) no-repeat;
            background-size: 100% 100%;
        }
        .img_show{
            width: 16px;
            height: 16px;
        }
        &:hover{
            .tips{
                height: 60px;
            }
            .tip_triangle{
                display: block;
            }
        }
        .tip_triangle{
            position: absolute;
            top: 25px;
            left: 5px;
            z-index: 3;
            width: 0;
            display: none;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 10px solid rgba(49, 88, 128, 0.9);
        }
        .tips{
            position: absolute;
            top: 35px;
            left: -11px;
            min-width: 220px;
            height: 0;
            overflow: hidden;
            line-height: 30px;
            background-color: rgba(49, 88, 128, 0.9);
            border-radius: 6px;
            text-align: left;
            padding: 0 10px;
            cursor: pointer;
            transition: height 0.5s;
            @include flex-box();
            .tip_icon{
                width: 40px;
                height: 60px;
                @include flex-box(center,center);
                img{
                    width: 30px;
                    height: 30px;
                }
            }
            .tip_text{
                .tip{
                    min-width: 180px;
                    height: 30px;
                    line-height: 30px;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectIndex/indexDefault/markerShow.vue